import numeral from "numeral";

export class SwedishNumberFormatter {
  /**
   * Format number to Swedish currency format using Numeral.js
   * @param {string|number} value - The value to format
   * @param {string} currency - Currency symbol (default: 'kr')
   * @returns {string} - Formatted currency string
   */
  static toCurrencyFormat(value?: any): string {
    if (!value) return "";
    return numeral(value).format(`0,0$`);
  }

  /**
   * Format number with thousand separators using Numeral.js
   * @param {string|number} value - The value to format
   * @param {number} maxDecimals - Maximum number of decimal places (default: 0)
   * @returns {string} - Formatted value with spaces as thousand separators
   */
  static toThousandSeparatedFormat(value?: any, maxDecimals = 0): string {
    if (!value) return "";

    const format = maxDecimals > 0 ? `0,0[.]${"0".repeat(maxDecimals)}` : "0,0";
    return numeral(value).format(format);
  }

  /**
   * Format number to integer using Numeral.js
   * @param {string} value - The value to format
   * @returns {string} - Formatted integer string
   */
  static formatInteger(value?: any): string {
    if (!value) return "";

    return numeral(value).format("0");
  }
}
